import { render, staticRenderFns } from "./PedidoManage.vue?vue&type=template&id=a1b5e82a&scoped=true"
import script from "./PedidoManage.vue?vue&type=script&lang=js"
export * from "./PedidoManage.vue?vue&type=script&lang=js"
import style0 from "./PedidoManage.vue?vue&type=style&index=0&id=a1b5e82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b5e82a",
  null
  
)

export default component.exports